<button
  cignaButton="link inline no-underline"
  (click)="previousOnboarding.emit()"
>
  <div class="cg-flex cg-flex-vertical-center">
    <cigna-icon type="chevron-circle-left" class="cg-link-color cg-icon-md">
    </cigna-icon
    ><span class="cg-margin-left-sm">Previous</span>
  </div>
</button>
<div class="cg-flex cg-margin-top-lg">
  <div class="cg-flex-item-equal-width left-card">
    <p class="current-step">{{ currentStep }} of {{ totalSteps }}</p>

    <div class="cg-margin-top-lg step-details">
      <ng-container *ngIf="currentStep === 1">
        <h3 class="cg-h3">What is a website access manager?</h3>
        <p>
          The website access manager oversees registration for
          <span *ngIf="appContext === 'chcp'">CignaforHCP.com</span>
          <span *ngIf="appContext === 'evernorth'">Provider.Evernorth.com</span>
          and grants the
          <cigna-popover [content]="accessPopover" areaLabelText="Access notes"
            >appropriate level of access</cigna-popover
          >
          to other users of the website. A website access manager has three key
          responsibilities that are important to help maintain the security of
          your information and that of your patients:
        </p>
        <ul class="cg-bullet-list">
          <li class="cg-bullet-list__item">
            <cigna-popover
              [content]="approvePopover"
              areaLabelText="Approve notes"
              >Approve</cigna-popover
            >
            access for new users.
          </li>
          <li class="cg-bullet-list__item">
            <cigna-popover
              [content]="assignPopover"
              areaLabelText="Assign notes"
              >Assign</cigna-popover
            >
            the appropriate entitlements, or functions to users.
          </li>
          <li class="cg-bullet-list__item">
            <cigna-popover [content]="auditPopover" areaLabelText="Audit notes"
              >Audit</cigna-popover
            >
            access by monitoring usage.
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="currentStep === 2">
        <h3 class="cg-h3">Approve access or edit existing users</h3>
        <p>
          You can approve access or edit existing users by navigating to Manage
          User Access under the
          <span *ngIf="appContext === 'chcp'">Working with Cigna tab</span>
          <span *ngIf="appContext === 'evernorth'">My Practice tab</span>.
        </p>
        <p>
          Locate and select the user(s) you wish to edit in the table then click
          the “view and edit selected users” button.
        </p>
        <h3 class="cg-h3 cg-margin-top-lg">
          How will I know if a user is requesting access?
        </h3>
        <p>
          When a new user has requested access, website access managers receive
          an email notification. Users waiting for access will appear in the
          Manage User Access section of your dashboard when you log in and on
          the Awaiting Access tab on the Manage User Access screen.
        </p>
      </ng-container>
      <ng-container *ngIf="currentStep === 3">
        <h3 class="cg-h3">Assign access</h3>
        <p>
          When you assign access, you will select which entitlements, or
          functions, the user(s) should have.
        </p>

        <p *ngIf="appContext === 'chcp'">
          To protect accounts and information, it is important that you only
          assign the entitlements the user needs to perform their job. For
          example, the Enroll and Manage EFT entitlement should only be granted
          to individuals with access to banking information.
          <a (click)="openExplainAccessDialog()"
            >Learn more about the functions each entitlement grants access
            to.</a
          >
        </p>

        <p *ngIf="appContext === 'evernorth'">
          <a (click)="openExplainAccessDialog()"
            >Learn more about the functions each entitlement grants access
            to.</a
          >
        </p>

        <p *ngIf="appContext === 'chcp'">
          If your group participates in a Cigna Collaborative Accountable Care
          program follow these
          <a (click)="openCCCDialog()"
            >instructions for assigning clinical reports entitlements.</a
          >
        </p>

        <p>
          Website access managers are not automatically granted access to all
          functions. You may need to assign additional entitlements to your own
          access as appropriate for your role.
        </p>
      </ng-container>
      <ng-container *ngIf="currentStep === 4">
        <h3 class="cg-h3">Audit User Access</h3>
        <p>
          The delegation history report allows you to view users tied to your
          Tax Identification Number(s) including:
        </p>
        <ul class="cg-bullet-list">
          <li class="cg-bullet-list__item">
            <cigna-popover
              [content]="entitlementsPopover"
              areaLabelText="Entitlement notes"
              >Entitlements</cigna-popover
            >
            assigned to them
          </li>
          <li class="cg-bullet-list__item">Last login date</li>
          <li class="cg-bullet-list__item">Registered contact information</li>
        </ul>

        <p>
          To access the report, go to delegation history report under the
          <span *ngIf="appContext === 'chcp'">Working with Cigna tab</span>
          <span *ngIf="appContext === 'evernorth'">My Practice tab</span>.
        </p>
      </ng-container>
      <ng-container *ngIf="currentStep === 5">
        <h3 class="cg-h3">Removing User Access</h3>
        <p>
          You can remove access by navigating to the Manage User Access page
          under the
          <span *ngIf="appContext === 'chcp'">Working with Cigna tab</span>
          <span *ngIf="appContext === 'evernorth'">My Practice tab</span>.
        </p>
        <p>
          Identify the users you would like to remove access for and then click
          the "Remove Access" link located in the status column.
        </p>
      </ng-container>

      <div class="cg-margin-top-xxl" *ngIf="currentStep < totalSteps">
        <button
          cignaButton="primary"
          (click)="continueOnboarding.emit()"
          class="cg-margin-right-md"
        >
          Continue
        </button>
        <button cignaButton="secondary" (click)="dismiss.emit()">
          Remind me later
        </button>
      </div>
      <div class="cg-margin-top-xl" *ngIf="currentStep === totalSteps">
        <button cignaButton="primary" (click)="completeOnboarding.emit()">
          Continue to Dashboard
        </button>
      </div>
    </div>
  </div>

  <div class="cg-flex-item-equal-width right-card">
    <img
      [height]="246"
      [width]="246"
      [src]="
        'assets/images/wam-onboarding/step-' +
          currentStep +
          '-' +
          appContext +
          '.svg' | cdnPrefix
      "
    />
    <div>
      <ng-container *ngIf="currentStep === 1">
        <h3 class="cg-h3">Multiple website access managers</h3>
        <p>
          Every Tax Identification Number (TIN) is required to have at least one
          website access manager. Cigna recommends at least two per TIN to
          ensure users can obtain the appropriate access in the event you are
          unavailable.
        </p>
      </ng-container>
      <ng-container *ngIf="currentStep === 2">
        <h3 class="cg-h3">Protect against unauthorized use</h3>
        <p>When approving new users, validate the following information:</p>
        <ul style="margin-left: 20px; text-align: left">
          <li>Is the email domain valid?</li>
          <li>
            Can you look the user up in a work directory or is the user with a
            vendor you trust?
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="currentStep === 3">
        <h3 class="cg-h3">Deciding how to assign access</h3>
        <p>
          After you choose to edit one or more users, the first step will be
          deciding how to assign the TINs and entitlements. If you choose to
          assign by Individual TIN, entitlements are assigned to each TIN and
          selected user separately. If you assign by Group of TINs, each
          selected user will receive the same TIN access and entitlements.
        </p>
      </ng-container>
      <ng-container *ngIf="currentStep === 4">
        <h3 class="cg-h3">
          Ensure website security with the delegation history report
        </h3>
        <p>
          Assign proper entitlements. Some grant access to personal health
          information, electronic funds transfer enrollment, and bank account
          information.
        </p>
        <p>
          Monitor use with the last login date. Remove users who are not active
          or may have left your organization.
        </p>
      </ng-container>

      <ng-container *ngIf="currentStep === 5">
        <h3 class="cg-h3">Access this information anytime</h3>
        <p>
          A list of FAQs containing all of this information is available on the
          Manage User Access screen help menu.
        </p>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #accessPopover>
  <p>
    For example, a user that only manages patient check-in does not need claim
    detail access. EFT entitlement should only be given to user that need access
    to bank account information.
  </p>
</ng-template>

<ng-template #approvePopover>
  <p>
    To approve access for new users, go to Manage User Access under the
    <span *ngIf="appContext === 'chcp'">Working with Cigna tab</span>
    <span *ngIf="appContext === 'evernorth'">My Practice tab</span>.
  </p>
</ng-template>

<ng-template #assignPopover>
  <p>
    To assign entitlements for users, go to Manage User Access under the
    <span *ngIf="appContext === 'chcp'">Working with Cigna tab</span>
    <span *ngIf="appContext === 'evernorth'">My Practice tab</span>.
  </p>
</ng-template>

<ng-template #auditPopover>
  <p>
    To audit access, go to Delegation History Report under the
    <span *ngIf="appContext === 'chcp'">Working with Cigna tab</span>
    <span *ngIf="appContext === 'evernorth'">My Practice tab</span>
    to access a report of users, including last login date and entitlements.
  </p>
</ng-template>

<ng-template #entitlementsPopover>
  <p>
    Entitlements control what functions a user has access to on
    <span *ngIf="appContext === 'chcp'">CignaforHCP.com</span>
    <span *ngIf="appContext === 'evernorth'">Provider.Evernorth.com</span>, such
    as patient search, claim details and electronic funds transfer enrollment
    and management.
  </p>
</ng-template>
